import React, { useState, useEffect } from 'react';

// Al finalizar una apuesta el servidor la BORRA (deleteConfig('bet')), asi que
// al volver a esta pestaña no hay nada que cargar. Guardamos el enunciado en
// local para poder relanzar en directo una prediccion recurrente sin
// reescribirla entera.
const DRAFT_KEY = 'apuestasDraft';

function readDraft() {
    try {
        const raw = localStorage.getItem(DRAFT_KEY);
        if (!raw) return null;
        const draft = JSON.parse(raw);
        if (!draft || !Array.isArray(draft.options)) return null;
        return draft;
    } catch {
        return null;
    }
}

function writeDraft(draft) {
    try {
        localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
    } catch { }
}

function clearDraft() {
    try {
        localStorage.removeItem(DRAFT_KEY);
    } catch { }
}

const Apuestas = () => {
    const [title, setTitle] = useState(() => {
        const draft = readDraft();
        return draft && typeof draft.title === 'string' ? draft.title : '';
    });
    const [options, setOptions] = useState(() => {
        const draft = readDraft();
        return draft && draft.options.length > 0 ? draft.options : [''];
    });
    const [winOption, setWinOption] = useState('');
    const [busy, setBusy] = useState(false);
    const [hasActiveBet, setHasActiveBet] = useState(false);

    useEffect(() => {
        getBet();
    }, []);

    // Persistimos tambien mientras se edita, no solo al crear: asi tampoco se
    // pierde una apuesta a medio escribir al cambiar de pestaña.
    useEffect(() => {
        writeDraft({ title, options });
    }, [title, options]);

    const getBet = () => {
        fetch('/api/adminLogin' + '?action=get&type=bet', {
            method: 'POST',
        }).then(response => response.json())
            .then(data => {
                // Sin apuesta activa el endpoint devuelve null: no tocamos el
                // estado para conservar el borrador ya cargado.
                if (!data || !data.text) {
                    setHasActiveBet(false);
                    return;
                }
                let parsedData;
                try {
                    parsedData = JSON.parse(data.text);
                } catch {
                    setHasActiveBet(false);
                    return;
                }
                // La apuesta activa manda sobre el borrador local.
                setTitle(parsedData.title || '');
                setOptions(parsedData.options && parsedData.options.length > 0 ? parsedData.options : ['']);
                setHasActiveBet(true);
            })
            .catch(() => setHasActiveBet(false));
    };

    const addOption = () => {
        setOptions([...options, '']);
    };

    const removeOption = (index) => {
        setOptions(options.filter((_, i) => i !== index));
    };

    const updateOption = (index, value) => {
        const newOptions = [...options];
        newOptions[index] = value;
        setOptions(newOptions);
    };

    const resetForm = () => {
        setTitle('');
        setOptions(['']);
        setWinOption('');
        setHasActiveBet(false);
        clearDraft();
    };

    const submitForm = () => {
        // El createdAt lo pone el servidor, para que la ventana de apuestas no
        // dependa del reloj del navegador del admin.
        const data = {
            title: title,
            options: options
        };
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
        };
        fetch('/api/adminLogin' + '?action=create&type=bet', requestOptions)
            .then(response => response.json())
            .then(data => {
                setHasActiveBet(true);
                console.log(data);
            });
        console.log({ title, options });
    };

    // Guardas contra doble clic y contra enviar la opcion vacia: dos peticiones
    // simultaneas pueden leer los ganadores antes de que ninguna borre la
    // apuesta, y una winOption vacia haria ganar a todo el mundo.
    const finishBet = () => {
        const option = parseInt(winOption, 10);
        if (!Number.isInteger(option) || busy) return;
        setBusy(true);
        fetch('/api/adminLogin' + '?action=delete&type=bet&winOption=' + option, {
            method: 'POST',
        }).then(response => response.json())
            .then(() => {
                setBusy(false);
                // Titulo y opciones se quedan a proposito: son el borrador para
                // relanzar la misma prediccion mas tarde.
                setHasActiveBet(false);
                setWinOption('');
            })
            .catch(() => setBusy(false));
    };

    const showingDraft = !hasActiveBet && (title !== '' || options.some(opt => opt !== ''));

    return (
        <div className='heroes'>
            {showingDraft && (
                <p>No hay apuesta activa — estos son los datos de la anterior. Pulsa "Crear apuesta" para lanzarla de nuevo.</p>
            )}
            <input
                placeholder="Título de la apuesta"
                value={title}
                className='userSearch'
                onChange={e => setTitle(e.target.value)}
            />

            {options.map((opt, index) => (
                <div key={index}>
                    <input
                        placeholder={`Opción ${index + 1}`}
                        value={opt}
                        className='userSearch'
                        onChange={e => updateOption(index, e.target.value)}
                    />
                    <button className='btnForallia' type="button" onClick={() => removeOption(index)}>
                        X
                    </button>
                </div>
            ))}
            <input
                placeholder="Opción ganadora"
                value={winOption}
                className='userSearch'
                onChange={e => setWinOption(e.target.value)}
            />
            <div className='navTops heroes unselectable'>
                <div onClick={addOption}>Añadir opción</div>
                <div onClick={submitForm}>Crear apuesta</div>
                <div onClick={finishBet}>{busy ? 'Finalizando...' : 'Finalizar Apuesta'}</div>
                <div onClick={resetForm}>Limpiar</div>
            </div>
        </div>
    );
};

export default Apuestas;
